export let ETabSwapRoutes=function(ETabSwapRoutes){ETabSwapRoutes["TabSwap"]="TabSwap";return ETabSwapRoutes;}({});